import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GojsLegendComponent } from './gojs-legend.component';

@NgModule({
  imports: [CommonModule, MatExpansionModule, FontAwesomeModule],
  declarations: [GojsLegendComponent],
  exports: [GojsLegendComponent],
})
export class GojsLegendModule {}
